import { Tooltip } from '@mui/material';
import type { Decision } from '@shared/core/policy';
import type { ReactNode } from 'react';

export const PolicyLockHint = ({
  decision,
  primaryMessage,
  children,
}: {
  decision?: Decision;
  primaryMessage?: string;
  children: ReactNode;
}) => {
  if (decision === undefined || decision.allowed) return <>{children}</>;

  return (
    <Tooltip title={primaryMessage ?? decision.message} arrow>
      <span className="block" data-testid="policy-lock-hint">
        {children}
      </span>
    </Tooltip>
  );
};
